module.exports = __webpack_public_path__ + "img/9788954431682.d9fc96b5.jpg";